<template>
  <a-modal
    :title="`${isModify ? '修改' : '新建'}账号`"
    :visible="visible"
    :confirm-loading="confirmLoading"
    @ok="submit"
    @cancel="handleCancel"
  >
    <a-form-model
      ref="form"
      :model="data"
      :rules="rules"
      :label-col="{ span: 4 }"
      :wrapper-col="{ span: 18 }"
    >
      <a-form-model-item label="用户类型" prop="type">
        <a-select v-model="data.type" style="width: 100%">
          <a-select-option
            v-for="item in spiderClassOptions"
            :key="item.spiderClassId"
            :value="item.type"
            >{{ item.spiderClassName }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item label="用户昵称" prop="accountName">
        <a-input v-model="data.accountName"></a-input>
      </a-form-model-item>

      <a-form-model-item label="账号" prop="account">
        <a-input v-model="data.account"></a-input>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
export default {
  props: {
    visible: Boolean,
    confirmLoading: Boolean,
    handleOk: Function,
    // handleCancel: Function,
    data: {
      type: Object,
      required: true
    },
    spiderClassOptions: Array,

    isModify: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      rules: {
        type: { required: true, message: '用户类型不可为空', trigger: 'blur' },
        accountName: { required: true, message: '用户昵称不可为空', trigger: 'blur' },
        account: { required: true, message: '账号不可为空', trigger: 'blur' }
      }
    }
  },

  methods: {
    handleCancel() {
      this.$refs.form.resetFields()
      this.$emit('closeModel')
    },
    submit() {
      this.$refs.form
        .validate()
        .then(() => {
          this.handleOk(this.data)
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="less" scoped></style>
